import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { useRequireAuth } from '../../context/AuthContext'
import { useRealtimeNotifications } from '../../hooks/useRealtimeNotifications'
import Sidebar from './Sidebar'
import Header from './Header'
import BottomNav from './BottomNav'

const Layout: React.FC = () => {
  useRequireAuth()
  useRealtimeNotifications()

  const [sidebarOpen, setSidebarOpen] = useState(false)

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onSidebarToggle={toggleSidebar} />

        <main className="flex-1 overflow-auto bg-gray-50 pb-16 lg:pb-0">
          <Outlet />
        </main>

        <BottomNav />
      </div>
    </div>
  )
}

export default Layout
